<div class="flex items-center justify-center lg:h-screen h-[calc(100vh-16rem)] min-h-0 w-full">
  <div class="no-click-card  bg-base-100/5 py-4 lg:px-16 lg:py-8 w-[80%] max-w-140 px-16 lg:w-2/3">
    <div class="grid gap-y-2 mb-3 w-full">
      <figure class="flex justify-center w-full">
        <img
          src="../../../assets/images/cegeka_logo.png"
          alt="Cegeka"
          class="max-w-50 min-w-32"
        />
      </figure>
      <figure>
        <img
          src="../../../assets/images/blueocean_cegeka_product.png"
          alt="BlueOcean - A Cegeka Product"
          class="min-h-8 w-auto"
        />
      </figure>
    </div>

  <!-- <h3 class="mx-auto text-base-100/75 text-xl leading-3 tracking-wider italic">"Secure the cloud. Empower your vision."</h3> -->

  <div class="card-body mt-8">
    <div class="card-actions flex flex-col items-center justify-center">
      <button (click)="login()" type="button"
        class="px-4 w-full py-2 xl:text-lg bg-primary/25 border-2 border-primary/50 hover:bg-primary/30 hover:border-2  rounded">
        Sign in
      </button>
      <button routerLink="/discover" type="button"
        class="px-4 w-full py-2 xl:text-lg bg-base-300/25 border-2 border-base-300/50  hover:bg-base-300/15 hover:border-2 rounded">
        Discover
      </button>
    </div>
  </div>
</div>